export default {
  plural: 'Метки',
  singular: 'Метка',
  new: 'Добавить метку',
  add: 'Добавить метки',
  change: 'Изменить метки',
  removeAllOtherTags: 'Удалить все остальные теги',
  select: 'Выбрать метки...'
};
